import { getFormValue } from '../utils'

export const prepareValuesForPreview = (eventType, formValues) => ({
  before_buffer_time: parseInt(getFormValue(eventType.before_buffer_time, formValues.beforeBuffer), 10),
  after_buffer_time: parseInt(getFormValue(eventType.after_buffer_time, formValues.afterBuffer), 10),
})
